import { jwtDecode } from "jwt-decode";
import moment from "moment";
import { useEffect } from "react";
import { EmptyField } from "../components/elements/Elements";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../constants/constants";
import { Tag } from "antd";

export const CONST_CREDENTIALS_KEY = "DGD^#&#^#*#&#*(^GDGE#^*&*%%%";

export const currentYear = () => new Date().getFullYear();

export function stringify(text: any) {
  return text?.replaceAll?.("_", " ");
}

export function capitalizeText(str: string) {
  return str
    ?.split(" ")
    ?.map((word) => word[0].toUpperCase() + word.slice(1))
    ?.join(" ");
}

export const returnObject = (show: any, object: any, alternate?: any) => {
  return show ? object : alternate || [];
};

export function addSelectOption(id: string, name?: string) {
  return { id, name: capitalizeText(name || stringify(id)) };
}

export const decodeUser = (token: string) => {
  try {
    const decoded = jwtDecode(token);
    return decoded;
  } catch (err) {
    // saving error
  }
};

export const getCredentials = () => {
  const res = window.localStorage.getItem(CONST_CREDENTIALS_KEY);
  return res ? JSON.parse(res) : null;
};

export const setCredentials = (value: any) => {
  window.localStorage.setItem(CONST_CREDENTIALS_KEY, JSON.stringify(value));
};

export const removeCredentials = () => {
  localStorage.clear();
};

export const getDisplayName = (user: any) => {
  const { first_name, last_name } = user || {};
  return `${first_name} ${last_name}`;
};

export const numberFormat = (value: number | any) =>
  Number(value || 0).toLocaleString();

export const formatDate = (value: any, format = DATE_FORMAT) => {
  if (value) return moment(value)?.format(format);
  return <EmptyField />;
};
export const formatDateTime = (value: any, format = DATE_TIME_FORMAT) => {
  if (value) return moment(value)?.format(format);
  return <EmptyField />;
};

export const getChangedFields = (oldData: any, newData: any) => {
  const changedFields: { [key: string]: any } = {};

  Object.keys(newData).forEach((key) => {
    if (oldData[key] !== newData[key]) {
      changedFields[key] = newData[key];
    }
  });

  return changedFields;
};

export const useLoadingSimulator = (setLoading: any, time = 1000) => {
  // SIMULATE LAODING
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, time);
  }, []);
};

export const getListRoute = (source: string) => {
  return `/list/${source}`;
};

export function addTagOption(data: any, options: any) {
  const { label, tag, exact, suffix, value } = options || {};
  const labelValue = data?.name || data?.[label];
  const tagValue = exact ? tag : data?.[tag];
  const id = data?.id || data?.[value];

  return {
    ...data,
    id,
    name: (
      <div className="flexSpaceCenter">
        <div className="capitalize">{stringify(labelValue)}</div>
        <Tag>
          {tagValue}
          {suffix}
        </Tag>
      </div>
    ),
    searchLabel: `${labelValue} ${tagValue}`,
  };
}

export const currencyFormat = (amount: number, currency = "UGX") => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount || 0);
};

export const unsetKeys = (object = {}, keys: any[]) => {
  const temp: any = { ...object };
  keys?.forEach((item: any) => {
    delete temp[item];
  });
  return temp;
};

export const getLoanGrade = (value: any) => {
  let color, label;

  switch (value) {
    case "A":
      label = "Very Low Risk";
      color = "green";
      break;
    case "B":
      label = "Low Risk";
      color = "lightgreen";
      break;
    case "C":
      label = "Moderate Risk";
      color = "yellow";
      break;
    case "D":
      label = "High Risk";
      color = "orange";
      break;
    case "E":
      label = "Very High Risk";
      color = "red";
      break;

    default:
      break;
  }

  return { color, label };
};

export const formatWalletNumber = (walletNumber: string | any) => {
  // add space every 4 digits
  return walletNumber?.replace(/(\d{4})/g, "$1 ").trim();
};

export const returnKeys = (obj: Record<string, any> | any, keys: string[]) => {
  return keys?.reduce((result, key) => {
    if (obj?.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
    return result;
  }, {} as Record<string, any>);
};

export const formatLargeNumber = (amount: any) => {
  const num = parseInt(amount);
  const format = (value: number, suffix: string) => {
    let str = value.toFixed(1);
    if (str.endsWith(".0")) str = str.slice(0, -2);
    return `${str}${suffix}`;
  };
  if (num >= 1000000000) {
    return format(num / 1000000000, "B");
  } else if (num >= 1000000) {
    return format(num / 1000000, "M");
  } else if (num >= 1000) {
    return format(num / 1000, "K");
  }
  return 0;
};
